/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled, { css } from "styled-components";
import Icon from "../Icon";

const baseStyles = css`
  width: 100%;
  padding: 7px 16px;
  font-size: calc(${({ theme }) => theme.fontSizes.p} * 0.875);
  font-family: inherit;
  line-height: 1.43;
  border: 1px solid rgba(${({ theme }) => theme.colors.border.rgba});
  border-radius: 8px;
  color: rgba(${({ theme }) => theme.colors.text.rgba});
  background: transparent;
  appearance: none;

  &::placeholder {
    color: rgba(${({ theme }) => theme.colors.textSecondary.rgba});
  }

  &:user-invalid {
    border-color: rgba(${({ theme }) => theme.colors.error.rgba});
  }

  ${(props) =>
    props.$error &&
    css`
      border-color: rgba(${props.theme.colors.error.rgba});
    `}
`;

export const StyledSelectWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const StyledSelectIcon = styled((props) => <Icon.ChevronDown color="dark" {...props} />)`
  display: flex;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`;

export const StyledFormField = {
  Input: styled.input`
    ${baseStyles}

    ${(props) =>
      props.$hasPrefix &&
      css`
        padding-left: 40px;
      `}

    ${(props) =>
      props.$hasSuffix &&
      css`
        padding-right: 40px;
      `}
  `,

  Select: styled.select`
    ${baseStyles}
    padding-right: 40px;
    cursor: pointer;
  `,

  Textarea: styled.textarea`
    ${baseStyles}
    resize: vertical;
    min-height: 100px;
  `,

  Search: styled.input`
    ${baseStyles}
    padding-left: 34px;
  `,
};
